import React, { useState, useEffect } from 'react';
import { Truck, Package, TrendingUp, Users } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LiveStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API}/public/live-stats`);
        setStats(res.data);
      } catch {
        setStats({ loads_this_week: 0, total_loads: 0, active_carriers: 0, quotes_this_week: 0 });
      }
    };
    fetchStats();
    const interval = setInterval(fetchStats, 60000);
    return () => clearInterval(interval);
  }, []);

  if (!stats) return null;

  const items = [
    { icon: Package, label: 'Loads This Week', value: stats.loads_this_week, color: 'text-red-500' },
    { icon: Truck, label: 'Active Carriers', value: stats.active_carriers, color: 'text-blue-500' },
    { icon: TrendingUp, label: 'Quotes This Week', value: stats.quotes_this_week, color: 'text-green-500' },
    { icon: Users, label: 'Total Loads Posted', value: stats.total_loads, color: 'text-orange-500' },
  ];

  return (
    <div className="bg-white border-y border-gray-200 py-6" data-testid="live-stats-bar">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-3 justify-center">
              <item.icon className={`w-8 h-8 ${item.color}`} />
              <div>
                <p className="text-2xl font-bold text-[#1e3a5f]">{item.value.toLocaleString()}</p>
                <p className="text-xs text-gray-500">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LiveStats;
